import React from 'react';
import ButtonsSearch from '../../../../../../components/NovoSistema/ButtonsSearch';
import { ContainerSection } from '../../../../../../components/NovoSistema/ContainerSection';
import InputText from '../../../../../../components/NovoSistema/InputText';
import SelectAndOptions from '../../../../../../components/NovoSistema/SelectAndOptions';
import { WrapperInputsNewSystem } from '../../../../../../components/NovoSistema/WrapperInputsNewSystem';

export default function CadDeDeptoN4Search() {
  return (
    <div>
      <ContainerSection>
        <h3>Pesquisa</h3>
        <WrapperInputsNewSystem>
          <InputText title="Razão Social" id="RazaoSocial" widthPercentage="30%" />
          <SelectAndOptions
            title="Tipo de Pessoa"
            id="TipoDePessoa"
            optionsArray={['', 'Física', 'Jurídica']}
            widthPercentage="30%"
          />
          <InputText title="CNPJ/CPF" id="CNPJCPF" widthPercentage="30%" />
        </WrapperInputsNewSystem>
        <WrapperInputsNewSystem>
          <SelectAndOptions
            title="Situação"
            id="Situacao"
            optionsArray={['', 'Ativa', 'Inativa']}
            widthPercentage="30%"
          />
        </WrapperInputsNewSystem>
        <ButtonsSearch />
      </ContainerSection>
    </div>
  );
}
